import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-exclamationMark",
  "use": "icon-exclamationMark-usage",
  "viewBox": "0 0 63 63",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 63 63\" id=\"icon-exclamationMark\"><title>prompt</title>\n<path d=\"M0,31.47A31.5,31.5,0,1,1,31.43,63,31.52,31.52,0,0,1,0,31.47Zm56,.07A24.5,24.5,0,1,0,31.43,56,24.51,24.51,0,0,0,56,31.54Z\" />\n<path d=\"M28,25.68V20a3.5,3.5,0,1,1,7,0V31.48a3.5,3.5,0,1,1-7,0C28,29.56,28,27.62,28,25.68Z\" />\n<path d=\"M31.49,39.67A3.5,3.5,0,1,1,28,43.14,3.52,3.52,0,0,1,31.49,39.67Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol